import { CommonSwitchButton } from 'components/common/buttons/switch-button';
import { ErrorBoundary } from 'components/common/error-boundary';
import { useState } from 'react';

export const FeatureDemoSwitchButton = () => {
  const [value, setValue] = useState<boolean>(false);

  return (
    <ErrorBoundary identifier="FeatureDemoSwitchButton">
      <CommonSwitchButton
        id="demo-switch-button"
        label="Switch Button"
        value={value}
        onChange={(v) => {
          console.debug(`FeatureDemo: switch button value changed to ${v}`);
          setValue(v);
        }}
        displayTrue="Value: ON"
        displayFalse="Value: OFF"
      />
    </ErrorBoundary>
  );
};
